import { QueryParams } from '@/model';
import apiClient from '../api/apiClient';
import { buildApiUrl } from '../utils';
import { GetPostResponse, GetPostsByUUIDResponse, PostPostsResponse, PutPostsResponse } from '../response/posts';

export class PostService {
  static getPost(params?: QueryParams) {
    return apiClient.get<GetPostResponse>(buildApiUrl('/api/v1/interactive-area/posts'), params);
  }

  static putPost(id: string, data: any) {
    const url = buildApiUrl('/api/v1/interactive-area/posts/:id', { id });
    return apiClient.updateWithFile<PutPostsResponse>(url, data);
  }

  static getPostByUUID(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/posts/:id', { id });
    return apiClient.get<GetPostsByUUIDResponse>(url, undefined);
  }

  static postPost(data: any) {
    return apiClient.createWithFile<PostPostsResponse>(buildApiUrl('/api/v1/interactive-area/posts'), data);
  }

  static deletePost(id: string) {
    const url = buildApiUrl('/api/v1/interactive-area/posts/:id', { id });
    return apiClient.delete<void>(url);
  }
}
